import React from 'react';
import styled from 'styled-components';
import { LoginForm } from './LoginForm';
import { RegisterForm } from './RegisterForm';
import glassTheme from '../../styles/glassTheme';

const ModalOverlay = styled.div.withConfig({
  shouldForwardProp: (prop) => prop !== 'visible',
})<{ visible: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.9);
  display: ${props => props.visible ? 'flex' : 'none'};
  justify-content: center;
  align-items: center;
  z-index: 2000;
  backdrop-filter: blur(10px);
`;

const CloseButton = styled.button`
  position: absolute;
  top: 1rem;
  right: 1rem;
  background: rgba(0, 0, 0, 0.5);
  border: 1px solid ${glassTheme.colors.border};
  color: ${glassTheme.colors.text.primary};
  font-size: 1.5rem;
  cursor: pointer;
  transition: all ${glassTheme.transition.base};
  z-index: 2001;
  width: 40px;
  height: 40px;
  border-radius: ${glassTheme.borderRadius.full};
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    transform: rotate(90deg);
    background: rgba(239, 68, 68, 0.3);
    border-color: ${glassTheme.colors.status.error};
    box-shadow: 0 0 20px ${glassTheme.colors.status.error};
  }
`;

interface AuthModalProps {
  visible: boolean;
  onClose: () => void;
  initialView?: 'login' | 'register';
}

export const AuthModal: React.FC<AuthModalProps> = ({
  visible,
  onClose,
  initialView = 'login'
}) => {
  const [currentView, setCurrentView] = React.useState<'login' | 'register'>(initialView);

  React.useEffect(() => {
    setCurrentView(initialView);
  }, [initialView]);

  const handleSwitchToRegister = () => {
    setCurrentView('register');
  };

  const handleSwitchToLogin = () => {
    setCurrentView('login');
  };

  return (
    <ModalOverlay visible={visible}>
      <CloseButton onClick={onClose}>
        <i className="fas fa-times"></i>
      </CloseButton>

      {currentView === 'login' ? (
        <LoginForm
          onSwitchToRegister={handleSwitchToRegister}
          onClose={onClose}
        />
      ) : (
        <RegisterForm
          onSwitchToLogin={handleSwitchToLogin}
          onClose={onClose}
        />
      )}
    </ModalOverlay>
  );
};